/* eslint-disable @typescript-eslint/no-explicit-any */
import { GetMeetingVideoRequest, GetMeetingVideoResponse } from '@eigtech/meetings-types'
import { HTTPError, contextualGet, queryOptions, useQuery } from '@eigtech/ui-shared-api'
import { meetingsBasePath, meetingsQueryKeys } from './constants'

const getMeetingVideo = ({ entityId, meetingId, startTime }: GetMeetingVideoRequest) =>
  contextualGet<GetMeetingVideoResponse>(
    `${meetingsBasePath}/meeting/video/${entityId}/${startTime}/${meetingId}`
  )

export const getMeetingVideoQueryOptions = ({
  entityId,
  meetingId,
  startTime,
}: GetMeetingVideoRequest) =>
  queryOptions({
    queryKey: meetingsQueryKeys.video({ entityId, meetingId }),
    queryFn: () => getMeetingVideo({ entityId, meetingId, startTime }),
    retry(failureCount, error: any) {
      // don't retry if error is 404 (not found)
      if (error instanceof HTTPError) {
        const responseStatus = error.response.status
        if (responseStatus === 404) return false
      }

      return failureCount < 3
    },
  })

export const useGetMeetingVideo = (request: GetMeetingVideoRequest) =>
  useQuery(getMeetingVideoQueryOptions(request))
